import { gql } from '@apollo/client';

export const AGENCY_COMMISSION = gql`
  mutation($userId: String!, $agencyCommission: Float!) {
    setAgencyCommission(user_id: $userId, commission: $agencyCommission) {
      status
    }
  }
`;
